import React from 'react';
import {
    BrowserRouter as Router,
    Redirect,
    Route,
    Switch
} from 'react-router-dom';
import { Provider } from 'react-redux';

import { IconMap, IconsPage } from './components/Icon';
import MainNav from './components/MainNav';
import DataPreload from './components/DataPreload';

import FindOrdersPage from './pages/FindOrdersPage';
import MyOrdersPage from './pages/MyOrdersPage';
import InboxPage from './pages/InboxPage';
import FinancesPage from './pages/FinancesPage';
import HelpPage from './pages/HelpPage';
import OrderStandalonePage from './pages/OrderStandalonePage';
import CommonFooter from './components/CommonFooter';
import Profile from './components/profile/Profile';
import Agreement from './components/agreement/Agreement';
import LoginPage from './pages/LoginPage';

const NotFoundPage = () => <p>404. The requested page is not found.</p>;

const LoggedContainer = props => {
    return (
        <DataPreload id="app">
            <Switch>
                <Route path="/order/:number" render={() => null} />
                <Route component={MainNav} />
            </Switch>

            <Switch>
                <Route path="/order/:id" component={OrderStandalonePage} />
                <Route path="/findorders" component={FindOrdersPage} />
                <Route path="/myorders" component={MyOrdersPage} />
                <Route path="/inbox" component={InboxPage} />
                <Route path="/finances" component={FinancesPage} />
                <Route path="/help" component={HelpPage} />
                <Route path="/icons" component={IconsPage} />
                <Redirect from="/" to={{ pathname: '/findorders', search: window.location.search }} push={false} />
                <Route component={NotFoundPage} />
            </Switch>

            <Agreement />
            <Profile />

        </DataPreload>
    );
};

const App = props => {
    return (
        <Provider store={props.store}>
            <Router>
                <div id="router">
                    <IconMap />
                    <Switch>
                        <Route path="/login/:token" component={LoginPage} />
                        <Route component={LoggedContainer} />
                    </Switch>

                    <Switch>
                        <Route path="/order/:number" render={() => null} />
                        <Route component={CommonFooter} />
                    </Switch>
                </div>
            </Router>
        </Provider>
    );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js